import { render, staticRenderFns } from "./WildCards.vue?vue&type=template&id=1a96ccfc&scoped=true&"
import script from "./WildCards.vue?vue&type=script&lang=js&"
export * from "./WildCards.vue?vue&type=script&lang=js&"
import style0 from "./WildCards.vue?vue&type=style&index=0&id=1a96ccfc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a96ccfc",
  null
  
)

component.options.__file = "WildCards.vue"
export default component.exports